<template>
  <div class="login-container">
    <div class="background-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>
    <div class="login-card">
      <div class="login-header">
        <h1 class="title">OH 社区运营平台</h1>
      </div>
      <div class="oauth-section">
        <a-button type="primary" size="large" block @click="handleOAuthLogin" :loading="oauthLoading"
          class="oauth-button" :class="{ pulse: isHovering }" @mouseenter="isHovering = true"
          @mouseleave="isHovering = false">
          使用 OpenAtom 账号登录
        </a-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { message } from 'ant-design-vue';
import axios from 'axios';

const oauthLoading = ref(false);
const isHovering = ref(false);

async function handleOAuthLogin() {
  oauthLoading.value = true;
  // 修改提示信息
  message.info('正在处理登录请求...');
  try {
    const state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('oauth_state', state);
    // const client_id = "10d64357e74f483b";
    // const redirect_uri = "http://openplatformoh.top/auth/callback";
    // const authUrl = `https://openatom.tech/login/oauth/authorize?client_id=${client_id}&state=${state}&redirect_uri=${redirect_uri}`;

    const res = await axios.get('/user/auth/getUrl', {
      params: { state }
    });
    const authUrl = res.data;

    // console.log(authUrl);

    // slight delay before redirecting
    setTimeout(() => {
      window.location.href = authUrl;
    }, 500);
  } catch (error) {
    window.alert('Server error:', error);
    this.$router.push('/login');
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 10%;
  min-height: 100vh;
  background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);
  position: relative;
  overflow: hidden;
}

.background-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
}

.shape-1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -100px;
  box-shadow: 0 0 60px rgba(255, 255, 255, 0.1);
}

.shape-2 {
  width: 200px;
  height: 200px;
  bottom: -80px;
  left: -80px;
  box-shadow: 0 0 40px rgba(255, 255, 255, 0.08);
}

.shape-3 {
  width: 150px;
  height: 150px;
  top: 30%;
  left: 10%;
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.06);
}

.login-card {
  width: 100%;
  max-width: 420px;
  padding: 50px 40px;
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(255, 255, 255, 0.2);
  text-align: center;
  z-index: 1;
  animation: fadeInUp 0.7s cubic-bezier(0.22, 0.61, 0.36, 1) forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-header {
  margin-bottom: 35px;
}

.logo {
  width: 70px;
  height: 70px;
  margin-bottom: 20px;
  filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.1));
}

.title {
  font-size: 32px;
  font-weight: 800;
  color: #2d3436;
  margin: 0 0 10px 0;
  letter-spacing: 0.5px;
}

.subtitle {
  font-size: 17px;
  color: #636e72;
  margin: 0;
  line-height: 1.5;
}

.oauth-section {
  margin-top: 30px;
}

.oauth-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  background: linear-gradient(to right, #0984e3, #00cec9);
  color: white;
}

.oauth-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px 0 rgba(0, 118, 255, 0.5);
  background: linear-gradient(to right, #087bc9, #00b8b3);
}

.oauth-button:active {
  transform: translateY(0);
  box-shadow: 0 2px 10px 0 rgba(0, 118, 255, 0.3);
}

.guest-button {
  height: 50px;
  font-size: 16px;
  font-weight: 500;
  color: #0984e3 !important;
  background: rgba(9, 132, 227, 0.08) !important;
  border: 1px solid #0984e3 !important;
  transition: all 0.3s ease;
}

.guest-button:hover {
  background: rgba(9, 132, 227, 0.15) !important;
  border-color: #0984e3 !important;
  transform: translateY(-1px);
  box-shadow: 0 3px 10px rgba(9, 132, 227, 0.2);
}

.guest-button:active {
  transform: translateY(0);
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  }

  50% {
    box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.5), 0 0 0 10px rgba(0, 118, 255, 0.1);
  }

  100% {
    box-shadow: 0 4px 14px 0 rgba(0, 118, 255, 0.39);
  }
}

.oauth-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

@media (max-width: 480px) {
  .login-card {
    padding: 40px 25px;
    margin: 0 15px;
    max-width: calc(100% - 30px);
  }

  .title {
    font-size: 28px;
  }

  .subtitle {
    font-size: 16px;
  }

  .oauth-button {
    font-size: 15px;
    height: 48px;
  }
}
</style>